import { AfterViewInit, Component, ElementRef, Input, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import * as d3 from "d3";
import { AllocationService } from 'src/app/api/services';
import { SharedService } from 'src/app/services/shared.service';
@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss']
})
export class MapComponent implements AfterViewInit {

  @ViewChild('map') map!: ElementRef;

  @Input() showcaseCode!: string;
  @Input() showcaseFloorCode!: string;
  @Input() mapPageView!: boolean;

  private initialScale: number = 0.3;
  private initilaTranslate: { x: number, y: number } =
    {
      x: 0,
      y: 0
    }

  protected floors: any[] = [];
  protected selectedFloor: number = 0;
  protected loading: boolean = false;
  protected mapSVG: any;

  constructor(
    public sharedService: SharedService,
    public allocationService: AllocationService,
    public translateService: TranslateService,
    private elRef: ElementRef
  ) { }

  ngAfterViewInit(): void {
    this.loadAllFloors()
  }

  loadAllFloors() {
    const event = this.sharedService.event;
    if (event) {
      this.loading = true
      if (event) {
        this.allocationService.getEventMap(event.id).subscribe(res => {
          this.floors = res.floors;
          this.setSelectedFloor();
          this.loading = false;

        }, err => {
          console.error(err);
          this.loading = false;
          this.sharedService.openSnackBar(this.translateService.instant(this.translateService.instant('ERROR_GENERIC_RETRY')), true);
        });
      }
    }
  }

  setSelectedFloor() {
    let index = 0;
    if (this.showcaseFloorCode) {
      index = this.floors.indexOf(
        this.floors.find(floor => {
          return floor.floorCode == this.showcaseFloorCode;
        })
      )
    }
    this.selectFloor(index)
  }

  isSelectedFloor(floor: string) {
    return this.floors[this.selectedFloor] === floor;
  }

  selectFloor(direction: number) {
    let index = this.selectedFloor + direction;
    if (index >= 0 && index < this.floors.length) {
      this.selectedFloor = index;
      let svgString = this.svgToString(this.floors[index].svg);

      try {
        //Inserisco l'html dell'svg direttamente nel div con id "image"
        const container = d3.select("#image").html(svgString);

        const svg = d3.select('#mappa');

        const g = d3.select('#mappa g');
        const zoomGroup = svg.append("g").attr("id", "zoomGroup");

        let svgBBox: any = (d3.select('#mappa').node() as any).getBBox();
        let svgRect: any = (svg.node() as any).getBoundingClientRect();
        let gRect: any = (g.node() as any).getBoundingClientRect();
        let proportion = svgBBox.width / gRect.width;

        let translateX = ((svgRect.width - gRect.width) / 2) * proportion;

        g.attr('transform', `translate(${translateX} 0)`);

        (zoomGroup.node() as any)!.appendChild(g.node());

        // Appende lo SVG al contenitore
        (container.node() as any).appendChild(svg.node());

        // Applica lo zoom
        svg.call((d3.zoom()
          .scaleExtent([0.5, 10])
          .on("zoom", (event) => {
            zoomGroup.attr("transform", event.transform);
          }) as any)
        );

        //Evidenzio il pallino dello shocase selezionato
        if (!this.mapPageView) {
          this.setHighligthClass();
        }
      }
      catch (err) {
        console.log(err);
      }
    }
  }


  svgToString(svg: string) {
    return svg.replaceAll("\n", "").replaceAll("\t", "");
  }

  getTransformValue(x: number, y: number, k: number) {
    if (k > 0) {
      return `translate(${x}, ${y})scale(${k})`;
    } else {
      return `translate(${x}, ${y})`;
    }
  }

  setHighligthClass() {
    try {
      let showcases = document.getElementsByClassName("showcase");
      let showcase = Array.prototype.slice.call(showcases).find(sc => sc.id === this.showcaseCode);

      showcase.childNodes[1].classList.add("highlight")
    }
    catch (err) { console.log(err) }
  }
}
